import dayjs from 'dayjs';

export function timeToDisplayFormat(time: string) {
  if (time.length === 3) time = `0${time}`;

  return [ time.slice(0, 2), ':', time.slice(2) ].join('');
}

export function timeToSystemFormat(time: string) {
  if (time.charAt(0) === '0') time = time.substring(1);

  return time.replace(':', '');
}

export function getTimeBeforePublish() {
  const minutes = dayjs().minute();
  let minutesBeforeUpdate = 0;

  if (minutes < 30) minutesBeforeUpdate = 30 - minutes;
  else minutesBeforeUpdate = 60 - minutes;

  if (minutesBeforeUpdate === 1) return '1';

  return `${minutesBeforeUpdate}`;
}
